import React, { Suspense } from 'react';
import ErrorBoundary from 'components/ErrorBoundary';

function LoadWidget() {
  return React.lazy(() => import(`./ArticleshowInsertSchedule`));
}

export default class ArticleshowInsertScheduleLoadable extends React.Component {
  constructor() {
    super();
    this.state = { Component: false };
  }

  componentDidMount() {
    this.setState({ Component: LoadWidget() });
  }

  render() {
    const { Component } = this.state;

    if (!Component) {
      return null;
    }

    return (
      <ErrorBoundary>
        <Suspense fallback={<div />}>
          <Component {...this.props} />
        </Suspense>
      </ErrorBoundary>
    );
  }
}
